import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Contexto
import { useModalsContext } from "@/contexts/ModalsContext";
// Componentes
import Modal from "@/components/Modals/Modal";
import InvitarAmigos from "@/components/Forms/InvitarAmigos";
// Utils
import { shareContent } from "@/utils/shareUtil";

export default function CardEvento({ evento }) {
  const { modals, openModal, closeModal } = useModalsContext();

  // Función para compartir el evento
  const handleShareEvento = async () => {
    const eventoUrl = `/evento/${evento?.id}`;
    
    await shareContent({
      url: eventoUrl,
      title: evento?.titulo || evento?.nombre || "Evento",
      text: `¡Mira este evento! ${evento?.titulo || evento?.nombre}`,
      successMessage: "¡Link del evento copiado al portapapeles!",
    });
  };

  return (
    <>
      <div className="relative bg-aw-bluedark-95 rounded-sm flex flex-col items-center w-full min-h-[60dvh] xl:min-h-[80dvh]">
        <img
          src={evento.img}
          alt={evento.titulo}
          className="absolute blur-lg backdrop-blur-3xl w-11/12 h-[40dvh] object-cover"
        />
        <img
          src={evento.img}
          alt={evento.titulo}
          className="rounded-sm w-full h-[40dvh] object-contain mb-4 z-50"
        />
        <div className="px-4 py-4 sm:py-8 flex flex-col items-center">
          <h5 className="text-xs text-gray-400 mb-1">{evento.fecha}</h5>
          <h1 className="text-lg font-medium text-white text-center mb-1">
            {evento.titulo}
          </h1>
          {evento.enDescuento && evento.subtitulo && (
            <h4 className="text-aw-green font-bold text-xl mb-2">
              {evento.subtitulo}
            </h4>
          )}
          <div className="flex justify-evenly w-full gap-3 mt-2">
            {/* <button className="w-10 h-10 rounded-full border border-white bg-aw-bluedark flex items-center justify-center text-white hover:bg-aw-green hover:text-aw-bluedark transition duration-300">
              <FontAwesomeIcon icon={"fa-solid fa-play"} className="text-lg" />
            </button>
            <button className="w-10 h-10 rounded-full border border-white bg-aw-bluedark flex items-center justify-center text-white hover:bg-aw-green hover:text-aw-bluedark transition duration-300">
              <FontAwesomeIcon icon={"fa-solid fa-heart"} className="text-lg" />
            </button> */}
            <button 
              onClick={handleShareEvento}
              className="w-10 h-10 rounded-full border border-white bg-aw-bluedark flex items-center justify-center text-white hover:bg-aw-green hover:text-aw-bluedark transition duration-300"
            >
              <FontAwesomeIcon
                icon={"fa-solid fa-share-alt"}
                className="text-lg"
              />
            </button>
            {/* <button
            onClick={() => openModal("invitarAmigos")}
             className="w-10 h-10 rounded-full border border-white bg-aw-bluedark flex items-center justify-center text-white hover:bg-aw-green hover:text-aw-bluedark transition duration-300">
              <FontAwesomeIcon icon={"fa-solid fa-users"} className="text-lg" />
            </button> */}
          </div>
        </div>
      </div>
      {modals.invitarAmigos && (
        <Modal
          isOpen={modals.invitarAmigos}
          onClose={() => closeModal("invitarAmigos")}
          large="max-w-4xl sm:max-w-3xl xl:max-w-5xl"
        >
          <InvitarAmigos closeInvitarAmigos={() => closeModal("invitarAmigos")} />
        </Modal>
      )}
    </>
  );
}
